/** 
 * IMPORTANT! this needs to be placed after content of ptpricing.js 
 */

RentabilityCalculator.prototype.writeOutput = function () {
	$href = $('#ptPricingRentaCalcLink').data('rentacalcurl');
	$('#ptPricingRentaCalcLink').attr('href', $href + rentaCalc.generatedURLVars);
}

RentabilityCalculator.prototype.generateURLVars = function (obj) {
	return '?users=' + this.users + '&country=' + this.country;
}


var timer_useramountnotice = 0;

RentabilityCalculator.prototype.beforePriceCalculatorUpdate = function () {
	// care for -1, 0, '' values
	var useramount = $('#useramount').val();
	if ((typeof useramount === "undefined")||(parseInt(useramount) === 0)||(useramount==''))
		useramount = 1; // when undefined amount of users, price for single user license is assumed. Leo, 18.12.2015
	priceCalc.users = useramount;
	
	var billinginterval = $('input:radio[name=billinginterval]:checked').val();
	if ((typeof billinginterval === "undefined")||(parseInt(billinginterval) === 0)||(billinginterval==''))
		billinginterval = 12; // when undefined amount of billing interval as 12 months is asumed . Flo (war vorher schon so im shop) , 26.09.2015
	priceCalc.billinginterval = billinginterval;
	
	priceCalc.featureset = $('input[name=featureset]:checked').val();
	priceCalc.integration = $('input[name=integration]:checked').val();
	updateVeevaNoForm();
	
	updateFiftyPlusNoForm();
	
	sanitizeUserAmount();
	sanitizeBillingCycle();

	sanitizeServicesDisplay();
	updateSelectedServicesinPriceCalc();
	
	updatePricingGuiBasedOnInputs();
	updateOrderOverview();
}

/**
 * Show the price information in the priceOverviewContainer and in shop-page
 * Note: it is weird that this is part of RentabilityCalculator. Could be pricecalculator but...priorities.
 */
RentabilityCalculator.prototype.afterPriceCalculatorUpdate = function () {
	$('#price').val(priceCalc.perUser);
	$('#pricedisplay').html(ptNumber.niceifyNumber(priceCalc.perUser));
	$('#pricedisplay2').html(ptNumber.sprintNumber(priceCalc.invoiceamount,2,true));
	
	$('#priceerror').hide();
	$('#priceline').show();
	$('#pricefootnote').show(); //LS: dead code? 4.8.14
	var priceintervalnotetext = '';
	if (priceCalc.billinginterval == 3) 
		priceintervalnotetext = pLang__('priceinterval3');
	else if (priceCalc.billinginterval == 12) 
		priceintervalnotetext = pLang__('priceinterval12');
	else
		priceintervalnotetext = ''; // should not happen			
	$('#priceintervalnote').html(priceintervalnotetext);
	
}

RentabilityCalculator.prototype.errorPriceCalculatorUpdate = function (e) {
	$('#pricedisplay, #pricedisplay2').html("");
	$('#priceline').hide();
	$('#pricefootnote').hide();
	$('#priceerror').html((e.message?e.message:e)).show();
}

RentabilityCalculator.prototype.afterRentabilityCalculatorUpdate = function () {
	$('.discounthintusers10').html(ptNumber.sprintNumber(priceCalc.getUsersDiscount(10),0,'spaced'));
	$('.discounthintusers50').html(ptNumber.sprintNumber(priceCalc.getUsersDiscount(50),0,'spaced'));
	$('.discounthintmonths12').html(ptNumber.sprintNumber(priceCalc.getBillingintervalDiscount(12),0,'spaced'));
	$('.discounthintmonths36').html(ptNumber.sprintNumber(priceCalc.getBillingintervalDiscount(36),0,'spaced'));
}

RentabilityCalculator.prototype.beforeInitialRun = function () {
	// update the currency symbols
	$('.insertCurrencySymbolHtml').html(ptShop.currencySymbolHtml);
	$('.insertCurrencySymbol').html(ptShop.currencySymbol);
	$('.insertCurrencySymbolHtml, .insertCurrencySymbol').attr('title', ptShop.currency);

	if (ptShop.currency == "BRL" && ptShop.language == 'pt') {
		$('.appendCurrency').html('Preço em reais');
	} else if (ptShop.currency != "EUR") {
		$('.appendCurrency').html(pLangF__('shoppriceincurrency', {currency: ptShop.currency}));
	} else {
		$('.appendCurrency').html(pLangF__('shopprice', {currency: ptShop.currency})); 
	}
	
	// remove the vat note in specific countries 
	if (ptShop.country && $.inArray(ptShop.country, ptShop.priceNoVatNoteCountries) !== -1) {
		$('#vatnote').hide();
	} else {
		$('#vatnote').show();
	}
	
	// display services prices and savings amounts	
	for(var servicename of ptShop.allshopservices) {
		$('.serviceContainer.'+servicename+' .saving .amount').html(ptNumber.sprintNumber(priceCalc.getServicePrices(servicename)[0],0,'spaced'));
		$('.serviceContainer.'+servicename+' .normal .amount').html(ptNumber.sprintNumber(priceCalc.getServicePrices(servicename)[1],0,'spaced'));
	}
	
}

function ptInitPricingGui() {

	ptStartShopCurrencyLoad();
	
	// Bind gui events 
	$('.triggerpriceinput').on('change', priceCalculatorUpdate);
	$('.triggerpricechange').on('change', priceCalculatorUpdate);
	
	sanitizePriceOverview($('#useramount').val());
	
	$('.featureContainer').on('click', function(){
		
		$('.featureContainer').removeClass('act');
		$(this).addClass('act');
		
		$('input[name=featureset]').removeAttr('checked');
		
		$thisValue = $(this).find('input:radio').attr('id');
		 
		$('input[name=featureset][value='+$thisValue+']').prop('checked',true).trigger('change');
		// note: this triggers priceCalculatorUpdate(); via the onchange handler registered based on class triggerpriceinput
	});
	
	
	$('.serviceContainer').on('click', function(){
		
		$cb = $(this).find('input:checkbox');
		
		if($cb.is(":checked")) {
			$cb.prop('checked', false).attr('checked', false).val(0); 
			$(this).removeClass('act');
			
			if($(this).hasClass('starterpaket') && !$(this).hasClass('alreadyOpened')) {
				$(this).addClass('alreadyOpened');
				$('body').addClass('shopModalOpen');
				$('.shopModal.starterpaket').show();
			}
			
		} else {
			$cb.prop('checked', true).attr('checked', true).val(1);
			$(this).addClass('act');
			$('body').removeClass('shopModalOpen');
		}
		
		priceCalculatorUpdate();
	});
	
	
	$('.shopModal .container').on('click', function(event){
		event.stopPropagation();
	});
	
	
	$('.shopModal.starterpaket .button').on('click', function(event){
		if($(this).hasClass('active')) {
			$('.serviceContainer.starterpaket').trigger('click');
		}
		$('.shopModal').hide();
		$('body').removeClass('shopModalOpen');
		
		return false;
	});
		
	$('.shopModal').on('click', function(){
		$(this).hide();
		$('body').removeClass('shopModalOpen');
	});
	
	$('.billingcycleContainer').on('click', function(){
		
		if($(this).find('input:radio').attr('disabled') != 'disabled') {
		
			$('.billingcycleContainer').removeClass('act');
			$(this).addClass('act');
			
			$('input[name=billinginterval]').removeAttr('checked');
			
			$thisValue = $(this).find('input:radio').attr('id').replace('billinginterval', '');
			 
			$('input[name=billinginterval][value='+$thisValue+']').prop('checked',true).trigger('change');
			// note: this triggers priceCalculatorUpdate(); via the onchange handler registered based on class triggerpriceinput
		}		
		

	});
	
	$('.chooseNumReps .featurePerRepColumn').on('click', function(){
		
		if($(this).find('input:radio').attr('disabled') != 'disabled') {
		
			$('.chooseNumReps .featurePerRepColumn').removeClass('act');
			$(this).addClass('act');
			
			$('input[name=useramountrange]').removeAttr('checked');
			
			$thisValue = $(this).find('input:radio').attr('id').replace('useramount', '');
			
			$('input[name=useramountrange][value='+$thisValue+']').prop('checked',true); // note: also set by updatePricingGuiBasedOnInputs
			
			$('#rcusers').val(parseInt($thisValue, 10));
			$('#useramount').val(parseInt($thisValue, 10)).trigger('change'); 
			// note: this triggers priceCalculatorUpdate(); via the onchange handler registered based on class triggerpriceinput 
			
		}
	});
	
	$('.integrationContainer').on('click', function(){
		
		if($(this).find('input:radio').attr('disabled') != 'disabled') {
			
			$('.integrationContainer').removeClass('act');
			$(this).addClass('act');
			
			$('input[name=integration]').removeAttr('checked');
			
			$thisValue = $(this).find('input:radio').attr('id');
			 
			$('input[name=integration][value='+$thisValue+']').prop('checked',true).trigger('change');
			
			var p = $thisValue;
			
			priceCalculatorUpdate();						
		}
	});

	// initial priceCalculatorUpdate()
	priceCalculatorUpdate();

	$('.toggle').on('click', function(e){
		
		e.preventDefault();
		
		if(!$(this).hasClass('disabled')) {
			
			if($(this).parent().hasClass('toggleContentShown') ) {
				$(this).parent().removeClass('toggleContentShown');
			} else {
				$(this).parent().addClass('toggleContentShown');
			}
			
		}
		
	});
	
	
	$('.slideToggleContainer input:checkbox').on('change', function(){
			updatePricingInputsBasedOnSingleMultiUser($(this));
	});
	
	ptInitSingleMultiToggle($('#useramount').val());
	
	$('.slideToggleContainer .onePerson, .slideToggleContainer .aTeam').on('click', function(){
		$('.slideToggleContainer input:checkbox').trigger('click');
	});
	
	var $initPricingPos = $('.priceOverviewContainer').offset().top;
	var $headerHeight = $('.header-container').height();
	
	$(window).on('scroll', function(){
		
		if(window.innerWidth > 767) {
			if($initPricingPos < window.scrollY+$headerHeight)
				$('.priceOverviewContainer').css('top', $('.header-container').height());
		}
	});

	/**
	 * https://gist.github.com/alex-gist/2025270, 
	 * LS: with the adaptation of only first-letter when only one letter typed 
	 * used at the /shop and at /apply
	 */
	$('.upperfirst').on('keydown', function(event) {
			var textBox = event.target;
			if (textBox.value.length==1) {
				var start = textBox.selectionStart;
				var end = textBox.selectionEnd;
				textBox.value = textBox.value.charAt(0).toUpperCase() + textBox.value.slice(1);
				textBox.setSelectionRange(start, end);
			}
	});
	
	// only numeric
	$('#useramount').numeric();
	
	
	
	
}

function ptInitSingleMultiToggle($useramount) {
	
	if($useramount > 1) {
		$('.slideToggleContainer .aTeam').addClass('act');
		$('.slideToggleContainer .onePerson').removeClass('act');
		$('.priceViewTeam').show();
		$('.priceViewOneUser').hide();
		$('#multiplelicencestoggle').attr('checked','checked');
	}
	
}

function updatePricingInputsBasedOnSingleMultiUser($input) {
	$('.slideToggleContainer .onePerson, .slideToggleContainer .aTeam').removeClass('act');
	$('.priceViewTeam, .priceViewOneUser').hide();
			
	if($input.is(':checked')) {
		
		$('.slideToggleContainer .aTeam').addClass('act');
		$('.priceViewTeam').show();
		$('#useramount').val(2);
		
	} else {
		
		$('#none').closest('.integrationContainer').trigger('click');	
		$('#useramount').val(1);
		$('#rp').closest('.featureContainer').trigger('click');
		$('#billinginterval12').closest('.billingcycleContainer').trigger('click');
		
		$('.slideToggleContainer .onePerson').addClass('act');
		$('.priceViewOneUser').show();
	}	
	
	$('#useramount').trigger('change');

}

/**
 * check if integration is veeva and if not show the order form
 */
function updateVeevaNoForm() {
	if($('#veevaContactUs').length > 0) {
		if($('input[name=integration]:checked').val() == "veeva") {
			$('#orderformDetails, .paymentPoweredBy').hide();
			$('#veevaContactUs').show();
		} else {
			$('#orderformDetails, .paymentPoweredBy').show();
			$('#veevaContactUs').hide();
		}
	}
}

/**
 * check if #useramount is > 49
 */
function updateFiftyPlusNoForm() {
	
	if($('#useramount').val() > 49) {
		$('#orderformDetails, .paymentPoweredBy').hide();
		$('#pricing').addClass('noOrderDetails');
	} else {
		$('#orderformDetails, .paymentPoweredBy').show();
		$('#pricing').removeClass('noOrderDetails');
	}
}

/**
 * sets the right checkmarks in the feature set table depending on featureset
 */
function setPricingTableToRp(to = false, rp = true) {
	$('.chooseNumReps .feat.to, .chooseNumReps .feat.rp, .specsContainer .feat.to, .specsContainer .feat.rp').removeClass('yes').addClass('no').text('no');
	if(to == true) {
		$('.chooseNumReps .feat.to, .specsContainer .feat.to').removeClass('no').addClass('yes').text('yes');
	}
	if(rp == true) {
		$('.chooseNumReps .feat.rp, .specsContainer .feat.rp').removeClass('no').addClass('yes').text('yes');
	}
}


/**
 * check wether the checkbox starterpaket should be displayed or not depending on user amount and featureset
 */
function sanitizeServicesDisplay(){
	
	var $featureset = $('input[name=featureset]:checked').val();
	var $useramount = $('#useramount').val();
	
	if($useramount > 1 && $useramount <= 9 && $featureset == 'rp') { 
		
		if($('.chooseService.starterpaket').hasClass('ishidden')) {
			$cb = $('.serviceContainer.starterpaket input:checkbox');
			$cb.prop('checked', true).attr('checked', true).val(1); 
			$('.serviceContainer.starterpaket').addClass('act');	
			$('.chooseService.starterpaket').show().removeClass('ishidden');
		}
		
	} else {
		$cb = $('.serviceContainer.starterpaket input:checkbox');
		$cb.prop('checked', false).attr('checked', false).val(0);
		$('.serviceContainer.starterpaket').removeClass('act');
		$('.chooseService.starterpaket').hide().addClass('ishidden');
	}
}

/**
 * adds every service that is selected via the checkbox to an array that is saved in pricecalc to be further used in calculating the price that is displayed in the summary
 */
function updateSelectedServicesinPriceCalc() {
	$selectedservices = [];
	$('.serviceContainer input').each(function(){
		if($(this).is(":checked")) {
			var servicename = $(this).attr('id');
			$selectedservices.push(servicename);// += $trenner+servicename;
		}
	});
	
	priceCalc.selectedservices = $selectedservices;	
}
	
function sanitizeUserAmount() {

	var $useramount = $('#useramount').val();
	var $integration = $('input[name=integration]:checked').val();
	var $featureset = $('input[name=featureset]:checked').val();
	
	if ('rp' != $featureset || 'api' == $integration) { 
		if($useramount < 2) {
			priceCalc.users = 2;
			$('#useramount').val(2);
		} 
	}
	
	// FS#12824 consistency check: dynamics && salesforce && veeva starts with 10 users
	if ('none' != $integration && 'api' != $integration) {
		if($useramount < 10) {
			if('veeva' == $integration) {
				priceCalc.users = 50;	
				$('#useramount').val(50);
			} else {
				priceCalc.users = 10;	
				$('#useramount').val(10);
			}
			
		}
	} 
	
	if ('none' == $integration) {
		if($useramount < 1) {
			priceCalc.users = 1;
			$('#useramount').val(1);
		}		
		
	} 
	
	sanitizePriceOverview($useramount);
	
	if ($useramount > 10000) {
		priceCalc.users = 10000;
		$('#useramount').val(10000);
	}
		
}

function sanitizePriceOverview($useramount) {
	if ($useramount > 49) {
		$('.belowfifty').hide();
		$('.fiftyplus').show();
		$('.chooseBillingCycle').hide();
		$('.supportWidgetButton.priceOverview').hide();
	} else {
		$('.belowfifty').show();
		$('.fiftyplus').hide();
		$('.chooseBillingCycle').show();
		$('.supportWidgetButton.priceOverview').show();
	}
}

function sanitizeBillingCycle() {
	/* 
	// FS#20476 - Territory Optimization: neue Preise auf Webshop
	// currently, the billinginterval is not changed by featureset or integration
	var $featureset = $('input[name=featureset]:checked').val();
	
	if ('rp' != $featureset) { 
		if(priceCalc.billinginterval < 12) {
			priceCalc.billinginterval = 12;
			$('input#billinginterval12').prop('checked',true);
		} 
	}*/
	
}

/**
 * Update the pricing gui that heavily changes when changing input:
 * chooseNumReps, billingcycleContainer.
 * Reads the selected inputs from the GUI, 
 * Selects visually the current chooseNumReps column based on useramount,
 * and also sets the hidden field useramountrange.
 */
function updatePricingGuiBasedOnInputs() {
	
	var $useramount = $('#useramount').val();
	var $featureset = $('input[name=featureset]:checked').val();
	var $integration = $('input[name=integration]:checked').val();
	var $billingCycle = $('input[name=billinginterval]:checked').val();
	
	setPricingTableToRp(ptShop.featureSets[$featureset].to, ptShop.featureSets[$featureset].rp);
	
	$('.chooseNumReps .featurePerRepColumn, .billingcycleContainer').removeClass('act').removeClass('disabled');
	$('.chooseNumReps .featurePerRepColumn, .billingcycleContainer').find('input:radio').attr('disabled', false);
	
	
	if ($useramount > 1 && $useramount < 10) {
		$('.chooseNumReps .featurePerRepColumn.twoPlusUsers').addClass('act');
	} else if ($useramount > 9 && $useramount < 50) {
		$('.chooseNumReps .featurePerRepColumn.tenPlusUsers').addClass('act');
	} else if ($useramount > 49) {
		$('.chooseNumReps .featurePerRepColumn.fiftyPlusUsers').addClass('act');
	} else {
		$('.chooseNumReps .featurePerRepColumn.oneUser').addClass('act');
	}
	
	// select the right useramountrange radio input
	$('.chooseNumReps .featurePerRepColumn.act').find('input:radio').prop('checked', true);
	
	if($billingCycle == 3) {
		$('.billingcycleContainer.three').addClass('act');
	} else {
		$('.billingcycleContainer.twelve').addClass('act');
	}
	
	$('.billingcycleContainer.act').find('input:radio').prop('checked', true);

	
	if ('rp' != $featureset) {
		// FS#20476 - no need to disable the 3-months for territory optimization anymore
		// $('.billingcycleContainer.three').addClass('disabled');
		// $('.billingcycleContainer.three').find('input:radio').attr('disabled', true);
		
		//if old index (remove after design update)
		$('.pricingCTA .to').hide();
	
	} else {
		//if old index (remove after design update)
		$('.pricingCTA .to').show();
	} 
	
	if ('rp' != $featureset || 'api' == $integration) {
	
		$('.chooseNumReps .featurePerRepColumn.oneUser').addClass('disabled');
		$('.chooseNumReps .featurePerRepColumn.oneUser').find('input:radio').attr('disabled', true);
	
	} 
	
	if ('none' != $integration && 'api' != $integration) {
		
		$('.chooseNumReps .featurePerRepColumn.oneUser, .chooseNumReps .featurePerRepColumn.twoPlusUsers').addClass('disabled');
		$('.chooseNumReps .featurePerRepColumn.oneUser, .chooseNumReps .featurePerRepColumn.twoPlusUsers').find('input:radio').attr('disabled', true);	
		if('veeva' == $integration) {
			$('.chooseNumReps .featurePerRepColumn.tenPlusUsers').addClass('disabled');
			$('.chooseNumReps .featurePerRepColumn.tenPlusUsers').find('input:radio').attr('disabled', true);
			if ($useramount < 50) {
				$('#useramount').val(50);
				$('.chooseNumReps .featurePerRepColumn.fiftyPlusUsers').addClass('act');
				priceCalculatorUpdate(this.event);
			}
		}	
		
	}
	
	if($('.pricingctabutton').length) {
		
		$('.pricingctabutton').each(function(){
			
			var link = $(this).find('a[href*=shop]');
			
			var $shopButtonHref = link.prop('href');
		
			$shopButtonHref = $shopButtonHref.split('?')[0];
			
			$shopButtonHref += '?featureset='+$featureset+'&useramount='+$useramount+'&integration='+$integration+'&billinginterval='+$billingCycle;
			
			link.prop('href', $shopButtonHref);
			
		});
		
	}
	
	if($('.pricing-page').length) {
		if($featureset == 'rpto') {
			$('.cta_rpto_pricing').show();		
			$('.cta_rp_pricing').hide();	
			$('.cta_to_pricing').hide();
		} else if ($featureset == 'to') {
			$('.cta_rp_pricing').hide();	
			$('.cta_rpto_pricing').hide();	
			$('.cta_to_pricing').show();
		} else {
			$('.cta_rp_pricing').show();	
			$('.cta_rpto_pricing').hide();	
			$('.cta_to_pricing').hide();
		}
		
		
	}
	
}


function updateOrderOverview() {
	var $useramount = $('#useramount').val();
	var $integration = $('input[name=integration]:checked').val();
	var $featureset = $('input[name=featureset]:checked').val()
	var $billingCycle = $('input[name=billinginterval]:checked').val()
	var $paymentType = $('input[name=paymentType]:checked').val()
	
	$('.placeYourOrder .service').hide();
	if($('#starterpaket').is(":checked")) {
		$('.placeYourOrder .starterpaket').show();
	}
	
	$('#odReps').text($useramount);
	$('#odBilling1, #odBilling2').text($billingCycle);
	
	$('.placeYourOrder .licence').hide();
	$('.placeYourOrder .licence.'+$featureset).show();
	$('.paymentMethod').hide();
	$('.paymentMethod.'+$paymentType).show();
	$('.integration').hide();
	$('.integration.'+$integration).show();
	
}

	
$(document).ready(function() { 
	// in print no pricing
	
	if (1 == ptCommon.pPrint )
		return;
	
	ptInitPricingGui();	
	
	$('#ptpricingfiftyplus').on('click', function(e){
    
      e.preventDefault();      
		  pSendGAEvent('pt_pricing_fiftypluscontact_click', {}, 'pricing gui send event gone wrong');
      window.location = $(this).attr('href');
        
  });
	
});
